import React from 'react';
import {Tooltip} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import {TooltipFormulaRenderer} from '../../TooltipFormulaRenderer';

export const OpportunityTooltip = (): JSX.Element => {
	const intl = useIntl();
	const {formatMessage} = intl;
	return (
		<Tooltip
			interactable={false}
			content={
				<TooltipFormulaRenderer
					items={[
						{
							title: formatMessage({id: 'report.project_portfolio.opportunity_status.cell.tooltip.title'}),
							description: formatMessage({
								id: 'report.project_portfolio.opportunity_status.cell.tooltip.description',
							}),
						},
					]}
				/>
			}
		>
			–*
		</Tooltip>
	);
};
